import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ToasterService } from '../services/ui/toaster.service';
import { catchError, tap, throwError } from 'rxjs';
import { AuthService } from '../services/infrastructure/auth.service';

export const errorResponseInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
) => {
  const toasterService: ToasterService = inject(ToasterService);
  const authService: AuthService = inject(AuthService);

  return next(request).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as { success?: boolean; message?: string; show_toast?: boolean } | null;
        // Exibe toast de sucesso globalmente apenas para mensagens explícitas da API (geralmente em mutações)
        if (body?.success === true && body?.message) {
          if (request.method !== 'GET') {
            toasterService.success(body.message);
          } else if (body?.show_toast) {
            toasterService.success(body.message);
          }
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 0:
          toasterService.error(
            'Não foi possível conectar ao servidor. Verifique sua conexão com a internet ou tente novamente mais tarde.',
          );
          break;
        case 400:
          toasterService.error(error.error?.message || 'Requisição inválida.');
          break;
        case 401:
          // Só exibe toast e invalida sessão uma vez; ignora 401s concorrentes
          if (authService.isAuthenticated()) {
            toasterService.error(error.error?.message || 'Sessão expirada. Faça login novamente.');
            authService.userUnauthorized(error.url || '');
          }
          break;
        case 403:
          toasterService.error('Você não tem permissão para acessar este recurso.');
          break;
        case 404:
          toasterService.error('Recurso não encontrado.');
          break;
        case 422:
          const messages = Object.values<string[]>(error.error?.errors || {});
          if (messages.length > 0) {
            messages.forEach((msgArray: string[]) => {
              toasterService.error(msgArray[0]);
            });
          } else if (error.error?.message) {
            toasterService.error(error.error.message);
          }
          break;
        case 500:
          toasterService.error('Ocorreu um erro no servidor. Tente novamente mais tarde.');
          break;
        default:
          toasterService.error('Ocorreu um erro inesperado. Tente novamente.');
          break;
      }

      return throwError(() => error);
    }),
  );
};
